import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ip_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on expired/invalid admin token
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    const hadToken = !!localStorage.getItem("ip_admin_token");
    const isAuthFail =
      status === 401 &&
      hadToken &&
      (detail === "Token expired" ||
        detail === "Invalid token" ||
        detail === "Missing token");
    if (isAuthFail) {
      localStorage.removeItem("ip_admin_token");
      if (window.location.pathname.startsWith("/admin")) {
        // hard reload so React picks up the cleared token and shows the login form
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);
